import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-625a907c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-select-filter" }
const _hoisted_2 = {
  class: "dropdown",
  ref: "dropdown"
}
const _hoisted_3 = {
  class: "btn border bg-white dropdown-toggle px-2 first-btn",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_4 = { class: "message-container" }
const _hoisted_5 = {
  class: "dropdown-menu w-100",
  ref: "dropdownElement"
}
const _hoisted_6 = { class: "form-check select-all" }
const _hoisted_7 = { class: "form-check-label ps-3" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Select All ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-divider" }, null, -1 /* HOISTED */))
const _hoisted_11 = { class: "form-check" }
const _hoisted_12 = { class: "form-check-label" }
const _hoisted_13 = ["id", "value", "onChange", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.message), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              checked: _ctx.options.length === _ctx.selectedItems.length,
              onChange: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleAllSelected()), ["prevent"]))
            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_8),
            _hoisted_9
          ])
        ]),
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "dropdown-item ps-3",
            key: item.value
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: `option${item.value}${index}`,
                  value: item.value,
                  onChange: ($event: any) => (_ctx.updateSelectedItems(item.value, $event)),
                  checked: _ctx.selectedItems.includes(item.value)
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13),
                _createTextVNode(" " + _toDisplayString(item.name), 1 /* TEXT */)
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */)
  ]))
}